import { Progress } from "@mantine/core";

export const BaseProgress = Progress